<template>
  <div class="content">
    <div class="search-box justify-align">
      <img @click="back" class="comback-img" :src="require('../../assets/'+appTheme+'/right_icon3.png')" alt="" />
      <div class="search-box-sec left-justifying">
        <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
        <input class="searchInput" v-model="searchValue" placeholder="搜一搜" type="text" />
      </div>
      <div class="btn" @click="clickSearchBtn">搜索</div>
    </div>
    <div class="search-items-box" v-if="list==''&& searchItems != ''">
      <div class="search-title">搜索发现</div>
      <div class="search-items-list">
        <div class="search-item" v-for="(item,index) in searchItems" :key="index" @click="clickSearchItem(item.text)">
          <div>{{item.text}}</div>
        </div>
      </div>
    </div>
    <div v-else class="search-goods-box">
      <van-list v-if="list.length"
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                :finished-text="finishedTxt"
                @load="moreList"
      >
        <div class="shop-box">
          <div class="shop-list">
            <div class="shop-item" v-for="(item,index) in list" :key="index">
              <div class="shop-item-box">
                <img class="shop-img" @click="goDes(item.id)" :src="item.image" alt="">
                <div class="title" @click="goDes(item.id)">
                  <!--              <div class="tag">￥1</div> -->
                  {{item.name}}
                </div>
                <div class="price-box justify-align">
                  <div class="price" @click="goDes(item.id)">￥{{item.price}}</div>
                  <img @click="shareClick(item)" :src="require('../../assets/'+appTheme+'/share_icon.png')" alt="" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </van-list>
      <div style="text-align: center;margin-top: 20vw;" v-if="list.length==0&&searchNull">暂无数据</div>
    </div>
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img class="img-goods goodsImg" :src="shareItem.image" alt="" />
          <div class="title">{{shareItem.name}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>

      </div>
    </van-overlay>
    <!--    分享商品-->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
    <!--    分享商品end-->
  </div>
</template>

<script>
// import { Toast } from 'vant';
// Vue.use(Toast);
import QRCode from "qrcode";
import {VueCanvasPoster} from "vue-canvas-poster";

export default {
  name: "searchList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      searchValue: '',
      active: 0,
      searchItems: [],
      list: [],
      loading: false,
      finished: false,
      curr: 0,
      wh:'500px',
      category_id: '',
      page: 1,
      immediateCheck:false,
      finishedTxt: '',
      comType:'',
      searchNull:false,
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      shareShow:false,
    }
  },
  beforeCreate: function() {
    // console.log('1')
    window.document.body.style.backgroundColor= '#fff'
  },
  beforeDestroy: function() {
    // console.log('2')
    window.document.body.style.backgroundColor= ''
  },
  components: {
    VueCanvasPoster
  },
  // 列表页面
  activated() {
    if (!this.$route.meta.isBack) { // false
      console.log('isBack',this.$route.meta.isBack)
      //isBack 时添加中router中的元信息，判读是否要缓存
     //清空原有数据
    // 重新加载
      let value = this.$route.query.type

      console.log('value', value)
      if (value != undefined){
        console.log('有值')
        this.comType = value
      } else {
        console.log('没有值')
      }
      console.log('immediate-check',this.immediateCheck)
      this.list = []
      this.loading = true
      this.finished = true
      console.log(this.list)

    } else { // 要缓存
      console.log('要缓存isBack',this.$route.meta.isBack)
      // 执行倒计时函数
    }
    this.$route.meta.isBack = false; // 通过这个控制刷新，否则会一直为true
    document.querySelector('body').setAttribute('style', 'background: #fff;')
  },
  beforeRouteLeave(to, from, next) { // 列表页面跳转到 详情页时，设置需要缓存 to: 即将要进入的目标 用一种标准化的方式 //from: 当前导航正要离开的路由 用一种标准化的方式
    // 去除背景色
    console.log('离开界面')
    document.querySelector('body').setAttribute('style', '')
    if (to.path == '/goodDetails') {
      //当离开的时候不是去首页的时候开启缓存
      from.meta.isBack = true;
      // console.log('meta',from.meta)
    }else {
      from.meta.isBack = false;
      this.list = []
      this.loading = true
      this.finished = true
      this.searchValue= ''
    }
    next()
  },
  created() {

  },
  methods: {
    shareShowHide(){
      this.shareItem = ''
      this.shareGoodsImg = ''
      this.qrcodeUrl = ''
      this.shareShow = false
      // console.log(this.qrcodeUrl)
      // console.log('shareItem',this.shareItem)
    },
    shareClick(goods){ // 生成二维码
      // console.log(goods)
      var that = this
      that.shareItem = goods
      that.shareGoodsImg = goods.image
      var id = goods.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/goodDetails?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'

      // console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          that.qrcodeUrl = qr;
          // console.log('qrcode',that.qrcodeUrl)
          this.shareShow = true

          this.drawPoster(qr)
        }
      });
      this.drawPoster()
    },
    drawPoster(qr){
      var that = this

      var total = this.shareItem.price * 0.95
      var price = total.toFixed(2);
      var discount = '折后优惠价：'+price
      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: that.shareGoodsImg,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '50px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.shareItem.name,
            css: [
              {
                top: '450px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px'
              }
            ]
          },
          {
            type: 'image',
            url: that.qrcodeUrl, // this.qrcodeUrl, //
            css: {
              width: '170px',
              height: '170px',
              top: '570px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "780px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          },
          // {
          //   type: 'rect',
          //   css: {
          //     width: '503px',
          //     height: '106px',
          //     right: '9px',
          //     bottom: '70px',
          //     color: '#feeb86',
          //
          //   }
          // },
          // {
          //   type: "text",
          //   text: "扫码购买立即享受95折",
          //   css: {
          //     bottom: "135px",
          //     left: "136px",
          //     width: "360px",
          //     maxLines:1,
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
          // {
          //   type: "text",
          //   text: discount, // 扫码购买立即享受95折 折后优惠价：15.2
          //   css: {
          //     bottom: "90px",
          //     left: "134px",
          //     width: "260px",
          //     maxLines:1,
          //     textAlign: 'center',
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    async getGoodList () {
      let that = this
      let data = ''
      if (this.comType !=''){
        data ={
          keyword: this.searchValue,
          page: 1,
          type:this.comType
        }
      } else {
        data ={
          keyword: this.searchValue,
          page: 1,
        }
      }

      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        // console.log('res',res)
        this.list = res.data.data
        if (this.list.length){
          this.searchNull = false
        } else {
          this.searchNull = true
        }
        // 加载状态结束
        this.loading = false;
        // console.log(this.list)
        if (res.data.data.length == res.data.total || res.data.last_page == res.data.current_page){ // 数据全部加载完
          this.finished = true; // 数据全部加载完
          // console.log('不加载')
          if(res.data.data == 0){
            this.finishedTxt = '暂无数据~'
          } else {
            this.finishedTxt = '没有更多了~'
          }
        }else {
          that.finished = false; // 不可以加载
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    async moreList(){
      // console.log('加载更多')
      var that = this
      this.page += 1;//页数+1
      var data = ''
      if (this.comType !=''){
        data ={
          keyword: this.searchValue,
          page: this.page,
          type:this.comType
        }
      } else {
        data ={
          keyword: this.searchValue,
          page: this.page,
        }
      }
      const res = await this.$Http.getGoodsList(data)
      // 加载状态结束
      this.loading = false;
      if (res.code == 200){
        // console.log('res',res.data.data)
        var arr = this.list.concat(res.data.data);
        // console.log(arr.length)
        that.list = arr
        // console.log('total',res.data.total + 'list'+ this.list.length)
        if (that.list.length == res.data.total) { // 数据全部加载完成
          this.finished = true;
          this.finishedTxt = '没有更多了~'
          // console.log('加载完毕')
        } else {
          this.finished = false;
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    back(){
      this.$router.go(-1);
    },
    goDes(id){
      this.$router.push({path:'/goodDetails',query: {id:id}})
    },
    clickSearchItem(e){
      this.searchValue = e
    },
    clickSearchBtn(){
      this.list= []
      if (this.searchValue == '') {
        // this.Toast('请输入内容');
        this.$toast('请输入内容');
        return false;
      } else {
        // goodClassify
        this.page = 1
        this.getGoodList()
        // this.$router.push({path:'/classifyList',query: {value: this.searchValue}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box{
  padding: 34px 42px 34px 27px;
  //background: #FDD80D;
  .comback-img{
    width: 20px;height: auto;display: inline-block;margin-right: 30px;
  }
  .search-box-sec{
    width: 500px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #F2F3F3;
    overflow: hidden;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 59px;
      line-height: 59px;width: 400px;
      margin-left: 10px;border: none;
      background: none;color: #282828;font-size: 28px;
    }

    input::-webkit-input-placeholder {
      color: #8C8C8C;font-size: 24px;
    }
    input::-moz-input-placeholder {
      color: #8C8C8C;font-size: 24px;
    }
    input::-ms-input-placeholder {
      color: #8C8C8C;font-size: 24px;
    }

  }
  .btn{
    width: 100px;
    height: 60px;line-height: 60px;
    text-align: center;
    background: #FDD80D;
    border-radius: 30px;margin-left: 20px;
  }
}
.search-items-box{
  padding: 30px;
  .search-title{
    font-size: 26px;font-weight: bold;text-align: left;
  }
  .search-items-list{
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;margin-top: 30px;
    .search-item{
      width: 50%;margin-bottom: 30px;text-align: left;
      div{
        background: #F6F6F6;
        border-radius: 5px;padding: 10px 25px;font-size: 24px;display: inline-block;
      }
    }
  }
}
.shop-list{
  padding: 0 24px;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 28px;
  .shop-item{
    width: 50%;text-align: center;margin-bottom: 20px;
    .shop-item-box{
      margin: 16px 0;border-radius: 10px; border: 1px solid #f5f5f3;
    }
    .shop-img{
      width: 100%;
      height: 343px;
    }
    .title{
      margin-top: 30px;font-size: 28px;font-weight: bold;
      color: #000000;text-align: left;padding: 0 10px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      .tag{
        display: inline-block;background: #F23926;
        border-radius: 5px;padding: 0 10px;font-size: 18px;color: #FFFFFF;font-weight: bold;
      }
    }
    .price-box{
      padding: 15px 10px 15px;
      .price{
        font-weight: bold;
        color: #F23926;font-size: 32px;
      }
      img{
        width: 50px;
        height: 50px;
      }
    }
  }
}
.shop-box .shop-list .shop-item:nth-child(odd) .shop-item-box{
  margin-right: 20px;
}
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 80px auto 30px;
  }
  .imageWrapper{
    background: #fff;width: 520px;margin: 0 auto;padding: 10px;text-align: center;
    border: 6px solid #FDD80D;
    border-radius: 20px;
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
  .goodsImg{
    width: 370px;
    height: 370px;
    border-radius: 10px;margin-top: 30px;
  }
  .title{
    width: 370px;margin:20px auto;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .qr-code-img{
    width: 175px;height: 175px;
  }
  .hint{
    padding-bottom: 20px;
  }
}
</style>
